import { cats } from "@/mocks/chigua";

const nav = [
  { href: "#home", label: "首页大厅" },
  { href: "#hot", label: "瓜田热榜" },
  { href: "#field", label: "正在蹲的瓜" },
  { href: "#line", label: "连瓜时间线" },
  { href: "#guide", label: "蹲帖指南" },
  { href: "#about", label: "关于瓜吧" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#home" className="flex items-center gap-2.5" aria-label="吃瓜吧 回到首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-base font-bold text-secondary-900">
                瓜
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl text-background-50">吃瓜吧</span>
                <span className="text-[11px] tracking-widest text-background-200/70">盖楼蹲帖 · 不掉线</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              把正在发生的瓜整理成可蹲的楼层，持续吃瓜、楼层跟进新进展，和瓜友一起等后续，更新随时顶上来。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-sm font-medium text-background-50">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {nav.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-200/80 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-medium text-background-50">瓜田分类</h4>
            <ul className="mt-4 flex flex-wrap gap-x-3 gap-y-2">
              {cats.slice(1).map((c) => (
                <li key={c}>
                  <a href="#field" className="text-sm text-background-200/80 transition-colors hover:text-background-50">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-background-200/70">
              线索反馈：tougao@chigua.example
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-200/60">© 2026 吃瓜吧 · 理性吃瓜，信息以官方为准</p>
          <p className="text-xs text-background-200/60">盖楼蹲帖 · 楼层跟进新进展 · 持续吃瓜</p>
        </div>
      </div>
    </footer>
  );
}